import { useRegion } from 'common/hooks/region';
import { useSegment } from 'common/hooks/segment';
import moment from 'moment';
import { FinalizeReport } from 'pages/PerDiemArchive/components/finalize-report';
import { DateRangeSpec } from 'pages/PerDiemArchive/components/selectors';
import { usePerDiemParams } from 'pages/PerDiemArchive/params';
import * as React from 'react';
import { DateRangeControls } from '../../components/controls';

export const DateRange: React.FC = () => {
  const { searchParams } = usePerDiemParams();

  const { track } = useSegment();

  // Construct a search if our params are valid
  const spec = React.useMemo(() => {
    const { startDate, endDate, shippingLine, container } = searchParams;
    if (startDate && endDate && shippingLine && container) {
      const s: DateRangeSpec = {
        mode: 'date-range',
        startDate: moment(startDate),
        endDate: moment(endDate),
      };
      return s;
    }

    return null;
  }, [searchParams]);

  // Segment tracking
  React.useEffect(() => {
    if (!spec) {
      return;
    }

    track(
      'Per Diem Report Searched',
      {
        radioButton: searchParams.mode,
        shippingLine: searchParams.shippingLine,
        containerType: searchParams.container,
        startDate: spec.startDate.format('YYYY-MM-DD'),
        endDate: spec.endDate.format('YYYY-MM-DD'),
        time: '',
        numberOfDays: spec.endDate.diff(spec.startDate, 'days'),
      },
      { includeUser: true }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spec]);
  const region = useRegion();

  const minStartDate = React.useMemo(() => {
    return moment(region.perDiemArchiveMinDate).startOf('day');
  }, [region]);

  return (
    <div className="space-y-8 pb-4">
      <div className="flex items-end space-x-6 px-16">
        <DateRangeControls className="flex-grow" minStartDate={minStartDate} />
        <FinalizeReport searchSpec={spec} />
      </div>
    </div>
  );
};
DateRange.displayName = 'PerDiemArchive.DateRange';
